import React, { DetailedHTMLProps, FC } from "react";
import classNames from "classnames";
import "./paragraph.css";

export interface ParagraphProps
  extends DetailedHTMLProps<
    React.HTMLAttributes<HTMLParagraphElement>,
    HTMLParagraphElement
  > {
  className?: string;
}

export const Paragraph: FC<ParagraphProps> = ({
  children,
  className,
  ...props
}) => {
  const paragraphClassName = classNames({
    "xvia-paragraph": true,
    [className as string]: !!className,
  });
  return (
    <p className={paragraphClassName} {...props}>
      {children}
    </p>
  );
};
